import React from 'react';
import './AcknowledgmentsPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';

const PAGE_ID = 'AcknowledgmentsPage';

// Авторы иконок с Flaticon (полный список — public/legal/flaticons_authors.txt).
// Условия бесплатной лицензии Flaticon требуют упомянуть автора со ссылкой на
// его профиль — здесь каждый уникальный автор упомянут ровно 1 раз
const FLATICON_AUTHORS = [
  {name: 'Muhammad Usman', url: 'https://www.flaticon.com/authors/muhammad-usman'},
  {name: 'Frey Wazza', url: 'https://www.flaticon.com/authors/frey-wazza'},
  {name: 'Meaicon', url: 'https://www.flaticon.com/authors/meaicon'},
  {name: 'Bsd', url: 'https://www.flaticon.com/authors/bsd'},
  {name: 'Magnific', url: 'https://www.flaticon.com/authors/magnific'},
  {name: 'Kirill Kazachek', url: 'https://www.flaticon.com/authors/kirill-kazachek'},
  {name: 'Edtim', url: 'https://www.flaticon.com/authors/edtim'},
  {name: 'Judanna', url: 'https://www.flaticon.com/authors/judanna'},
  {name: 'Maxim Basinski Premium', url: 'https://www.flaticon.com/authors/maxim-basinski-premium'},
  {name: 'Pixel Perfect', url: 'https://www.flaticon.com/authors/pixel-perfect'},
  {name: 'Adrianadam', url: 'https://www.flaticon.com/authors/adrianadam'},
  {name: 'Marz Gallery', url: 'https://www.flaticon.com/authors/marz-gallery'},
  {name: 'Lafs', url: 'https://www.flaticon.com/authors/lafs'},
  {name: 'Mayor Icons', url: 'https://www.flaticon.com/authors/mayor-icons'},
  {name: 'Bearicons', url: 'https://www.flaticon.com/authors/bearicons'},
  {name: 'Smashingstocks', url: 'https://www.flaticon.com/authors/smashingstocks'},
  {name: 'Md Tanvirul Haque', url: 'https://www.flaticon.com/authors/md-tanvirul-haque'},
  {name: 'Kornkun', url: 'https://www.flaticon.com/authors/kornkun'},
  {name: 'Icongeek26', url: 'https://www.flaticon.com/authors/icongeek26'},
  {name: 'Dinosoftlabs', url: 'https://www.flaticon.com/authors/dinosoftlabs'},
  {name: 'Febrian Hidayat', url: 'https://www.flaticon.com/authors/febrian-hidayat'},
  {name: 'Imaginationlol', url: 'https://www.flaticon.com/authors/imaginationlol'},
  {name: 'Andrejs Kirma', url: 'https://www.flaticon.com/authors/andrejs-kirma'},
  {name: 'Bharat Icons', url: 'https://www.flaticon.com/authors/bharat-icons'},
  {name: 'Creaticca Creative Agency', url: 'https://www.flaticon.com/authors/creaticca-creative-agency'},
  {name: 'Afif Fudin', url: 'https://www.flaticon.com/authors/afif-fudin'},
  {name: 'Ayub Irawan', url: 'https://www.flaticon.com/authors/ayub-irawan'},
  {name: 'Maniprasanth', url: 'https://www.flaticon.com/authors/maniprasanth'},
  {name: 'Rikas Dzihab', url: 'https://www.flaticon.com/authors/rikas-dzihab'},
  {name: 'Vitaly Gorbachev', url: 'https://www.flaticon.com/authors/vitaly-gorbachev'},
  {name: 'Juicy Fish', url: 'https://www.flaticon.com/authors/juicy-fish'},
  {name: 'Vectors Tank', url: 'https://www.flaticon.com/authors/vectors-tank'},
  {name: 'Adury5711', url: 'https://www.flaticon.com/authors/adury5711'},
  {name: 'Debi Alpa Nugraha', url: 'https://www.flaticon.com/authors/debi-alpa-nugraha'},
  {name: 'Roundicons Premium', url: 'https://www.flaticon.com/authors/roundicons-premium'},
  {name: 'Kirill Kazachek', url: 'https://www.flaticon.com/authors/kirill-kazachek'},
  {name: 'sonnycandra', url: 'https://www.flaticon.com/authors/sonnycandra'},
  {name: 'Hight Quality Icons', url: 'https://www.flaticon.com/authors/hight-quality-icons'},
  {name: 'Anjunasa Zayyan Althea Mulya', url: 'https://www.flaticon.com/authors/anjunasa-zayyan-althea-mulya'},
];

function AcknowledgmentsPage({onBack}) {
  usePageAnalytics('AcknowledgmentsPage');

  return (
    <>
      <PageButton
        className="acknowledgments-floating-back-button"
        onClick={onBack}
        pageId={PAGE_ID}
        buttonId="back_floating"
      >
        <img
          className="acknowledgments-floating-back-button_icon"
          src="/img/icons/back_navigation.png"
          alt="Назад"
          title="Назад"
        />
      </PageButton>

      <h1 className="legal-page-title">Благодарности</h1>

      <div className="acknowledgments-content">
        <section className="acknowledgments-section acknowledgments-thanks">
          <p>
            Мы выражаем искреннюю и глубокую благодарность всем ранним тестировщикам игры.
            Именно благодаря вам, вашему терпению, энтузиазму и бесчисленным отзывам проект смог
            обрести свою форму.
          </p>
          <p>
            На протяжении сотен партий и тысяч часов вы помогали оттачивать механики, настраивать
            баланс и находить самые неожиданные грани игрового процесса. Каждая сыгранная партия,
            каждое замечание и каждая идея стали важным вкладом в развитие Стратегикона.
          </p>
          <p className="acknowledgments-thanks-closing">
            Спасибо, что были с нами с самого начала!
          </p>
        </section>

        <section className="acknowledgments-section">
          <h2 className="acknowledgments-section-title">Атрибуция</h2>
        </section>

        <section className="acknowledgments-section">
          <h2 className="acknowledgments-section-title">
            1. Использование контента, созданного с помощью искусственного интеллекта (ИИ)
          </h2>
          <p className="acknowledgments-paragraph">
            В Игре используются изображения, иконки, карточки и другой визуальный контент,
            сгенерированный технологиями искусственного интеллекта (ИИ).
          </p>
          <h3 className="acknowledgments-subsection-title">Используемые инструменты ИИ:</h3>
          <ol className="acknowledgments-list">
            <li>Google Gemini.</li>
            <li>Шедеврум (YandexART).</li>
          </ol>
          <p className="acknowledgments-paragraph">
            Все изображения, созданные с помощью ИИ и используемые в Игре, были получены на
            законных основаниях. Мы не заявляем, что изображения созданы исключительно человеком
            без участия ИИ.
          </p>
          <p className="acknowledgments-paragraph">
            В описании Игры, Политике Конфиденциальности, Лицензионном соглашении и на этой
            странице мы открыто указываем, что визуальный контент создан с помощью технологий ИИ.
          </p>
        </section>

        <section className="acknowledgments-section">
          <h2 className="acknowledgments-section-title">
            2. Использование звуков из библиотек Splice и Uppbeat
          </h2>
          <p className="acknowledgments-paragraph">
            В Игре используются звуковые эффекты и музыкальные элементы (далее – Звуки) из
            библиотеки Splice Sounds.
          </p>
          <p className="acknowledgments-paragraph">
            Мы используем Звуки из Splice в строгом соответствии с условиями использования
            платформы. В случае необходимости мы можем предоставить сертифицированную лицензию
            (Certified License) для подтверждения легальности использования каждого звука.
          </p>
          <p className="acknowledgments-paragraph">
            В Игре также используются звуковые эффекты из библиотеки Uppbeat (uppbeat.io). Права на
            эти звуки принадлежат их авторам и правообладателям. С вопросами о них можно написать
            на strategikon.game@yandex.ru.
          </p>
        </section>

        <section className="acknowledgments-section">
          <h2 className="acknowledgments-section-title">
            3. Использование визуальных материалов Flaticon
          </h2>
          <p className="acknowledgments-paragraph">
            В оформлении Игры используются иконки с сервиса Flaticon (
            <a
              className="acknowledgments-link"
              href="https://www.flaticon.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.flaticon.com
            </a>
            ).
          </p>
          <p className="acknowledgments-paragraph">
            Мы благодарим авторов за их труд и качественные материалы:
          </p>
          <ul className="acknowledgments-authors-list">
            {FLATICON_AUTHORS.map((author) => (
              <li key={author.url}>
                <a
                  className="acknowledgments-link"
                  href={author.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {author.name}
                </a>
              </li>
            ))}
          </ul>
          <p className="acknowledgments-paragraph">
            Все иконки используются на условиях бесплатной лицензии Flaticon с обязательной
            атрибуцией автора.
          </p>
        </section>

        <section className="acknowledgments-section">
          <p className="acknowledgments-paragraph">
            Пользователь не приобретает прав на использование, копирование или распространение
            визуального контента и Звуков из Игры за её пределами. Весь визуальный контент и Звуки
            являются частью игрового контента и предоставляются Пользователю исключительно для
            использования в рамках игрового процесса на условиях Политики Конфиденциальности и
            Лицензионного соглашения.
          </p>
          <p className="acknowledgments-paragraph">
            Если у вас есть вопросы по поводу использования визуального контента, ИИ-контента
            и/или Звука в Игре, вы можете связаться с нами по адресу:{' '}
            <a className="acknowledgments-link" href="mailto:strategikon.game@yandex.ru">
              strategikon.game@yandex.ru
            </a>
          </p>
        </section>
      </div>

      <div className="main-menu-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default AcknowledgmentsPage;
